<div class="card col-5" style="border: 1px solid rgb(41 223 198 / 13%);position: relative;height: 380px; width: 195px;margin-bottom: 10px;margin-left: 10px;">
    <div class="imageCover" style="height: 75%;width: 100%;position: relative;">
      <a [routerLink]="['/products/product-details/',item.Id]" style="cursor: pointer;">
        <img src="{{httpHelperService.imageUrl}}?referenceId={{item.Id}}&referenceTypeId=22" class="card-img-top" alt="..." 
        style="height: 200px;position: absolute;left: 0%;top: 0%;">
        <!-- <img src="./assets/images/service2.jpg" class="card-img" alt="..." style="  height: 100%; -->
        <!-- width: 95%;border-radius: 6px;
        object-fit: fill;">-->
      </a>
    </div>
    <div class="product-overlay" [style.right]="txtDir == 'rtl'?'10px':'auto'">
      <!-- <div class="first-child"><i class="fas fa-eye" (click)="selectProduct(item)" style="color: #26c113;"></i></div> -->
      <!-- <div><i class="fas fa-cart-plus"  (click)="openDialog(item)"></i></div> -->
      <!-- <div><i class="far fa-heart" style="color: #26c113;"></i></div> -->
    </div>
  <div class="card-body">
    <h3  class="card-title" style="font-size: 10px;font-weight: bold;width: 120%;overflow: hidden;    text-align: center">{{item.ItemName}}</h3>
    <p class="card-desc" style="text-align: center;">
      <i class="fas fa-star" style="color: #f1ce22;"></i>
      <i class="fas fa-star" style="color: #f1ce22;"></i>
       <i class="fas fa-star" style="color: #f1ce22;"></i>
       <i class="fas fa-star" style="color: #f1ce22;"></i>
       <i class="far fa-star"></i>
      </p> 
    <p style="position: absolute;top:0px;left:0px;background-color: #f19641;padding: 3px 10px;
    border-radius: 4px;;color: #fff;" class="price">{{item.ItemPrice}} EGP</p>
   <a class="btn btn-primary  addToCart" (click)="openDialog(item)" style="background-color: #f19641;"> {{translation['Add To Card']}}&nbsp;<i class="fa fa-cart-plus"></i></a>
  </div>
</div>

